import {fetchWrapper} from "@/helpers/fetchWrapper"
import backendRoutes from "@/backendRoutes"
import {ApiPlatformParser} from "@/helpers/apiPlatformParser"
import jsPDF from "jspdf"
import autoTable, {CellInput} from "jspdf-autotable"
import {Student} from "@/interfaces/student"
import {useAppLoadingStore} from "@/stores/appLoading.store"
import moment from "moment/moment"
import {i18n} from "@/main"

let students: Student[] = []

export default async function generateStudentsWithValidInsurancePdf(): Promise<void>{
    useAppLoadingStore().setLoading()
    await fetchListApi()
    useAppLoadingStore().unsetLoading()
}

async function fetchListApi(): Promise<void>{
    const response = await fetchWrapper.get(backendRoutes.student_with_valid_insurance)
    const apiPlatformParser: ApiPlatformParser = new ApiPlatformParser(response, ApiPlatformParser.LIST_TYPE)
    students = apiPlatformParser.getData()
    await exportPdf()
}

async function exportPdf():  Promise<void> {
    const pdf: jsPDF = new jsPDF()
    const text: string = i18n.global.t("admin_services.file_generator.students_with_valid_insurance.title") +  moment().format('DD/MM/YYYY')
    const xOffset: number = (pdf.internal.pageSize.width / 2)
    pdf.text(text, xOffset, 10, {align: 'center'})
    autoTable(pdf,{
        head: [[
            i18n.global.t("admin_services.file_generator.students_with_valid_insurance.columns.id"),
            i18n.global.t("admin_services.file_generator.students_with_valid_insurance.columns.firstname"),
            i18n.global.t("admin_services.file_generator.students_with_valid_insurance.columns.name"),
            i18n.global.t("admin_services.file_generator.students_with_valid_insurance.columns.email"),
            i18n.global.t("admin_services.file_generator.students_with_valid_insurance.columns.phone")]],
        body: students.map(student => [student.id as CellInput, student.firstname as CellInput, student.name as CellInput, student.email as CellInput, student.phone as CellInput])
    })
    pdf.save('students.pdf')
}